import { render, staticRenderFns } from "./aceite.vue?vue&type=template&id=42cbd4b4"
import script from "./aceite.vue?vue&type=script&lang=ts"
export * from "./aceite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports